/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamSummary } from './TournamentTeamSummary';
import {
    TournamentTeamSummaryFromJSON,
    TournamentTeamSummaryFromJSONTyped,
    TournamentTeamSummaryToJSON,
    TournamentTeamSummaryToJSONTyped,
} from './TournamentTeamSummary';

/**
 * 
 * @export
 * @interface ClassificationPosition
 */
export interface ClassificationPosition {
    /**
     * 
     * @type {string}
     * @memberof ClassificationPosition
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassificationPosition
     */
    classificationId?: string;
    /**
     * 
     * @type {number}
     * @memberof ClassificationPosition
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationPosition
     */
    teamId?: string | null;
    /**
     * 
     * @type {TournamentTeamSummary}
     * @memberof ClassificationPosition
     */
    team?: TournamentTeamSummary;
}

/**
 * Check if a given object implements the ClassificationPosition interface.
 */
export function instanceOfClassificationPosition(value: object): value is ClassificationPosition {
    return true;
}

export function ClassificationPositionFromJSON(json: any): ClassificationPosition {
    return ClassificationPositionFromJSONTyped(json, false);
}

export function ClassificationPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassificationPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'classificationId': json['classificationId'] == null ? undefined : json['classificationId'],
        'position': json['position'] == null ? undefined : json['position'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'team': json['team'] == null ? undefined : TournamentTeamSummaryFromJSON(json['team']),
    };
}

export function ClassificationPositionToJSON(json: any): ClassificationPosition {
    return ClassificationPositionToJSONTyped(json, false);
}

export function ClassificationPositionToJSONTyped(value?: ClassificationPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'classificationId': value['classificationId'],
        'position': value['position'],
        'teamId': value['teamId'],
        'team': TournamentTeamSummaryToJSON(value['team']),
    };
}

